import { useContext } from 'react';

import { Button } from '@chakra-ui/react';
import { toast } from 'react-toastify';

import { DealStateEnum } from '../../gql/dealGql';
import { useDealDetailNetsuiteMutation } from '../../gql/generated/graphql';

import { DealActionsEnum, DealContext } from '../../libs/DealContext';
import { logger } from '../../libs/Logger';

const SendToNetsuiteButton = () => {
  const { deal, dispatch } = useContext(DealContext);
  const [detailsDealNS, { loading }] = useDealDetailNetsuiteMutation();

  const handleSendToNetsuite = async () => {
    try {
      await detailsDealNS({
        variables: { id: deal.id ?? -1 },
      });

      dispatch({
        type: DealActionsEnum.UpdateDeal,
        payload: {
          // If the mutation is successful, we know it was sent to Netsuite
          sent_to_netsuite: true,
        },
      });
      toast.success('Sent to Netsuite!');
    } catch (e) {
      logger.error('SendNetsuiteButton.tsx', '', null, e);
      toast.error('Failed to "Sent to Netsuite". Please refresh the page');
    }
  };

  return (
    <Button
      variant="secondary"
      isLoading={loading}
      loadingText="Sending..."
      hidden={deal.state !== DealStateEnum.Funded}
      onClick={handleSendToNetsuite}
      isDisabled={deal.sent_to_netsuite}
    >
      {deal.sent_to_netsuite ? 'SENT' : 'SEND'} TO NETSUITE
    </Button>
  );
};

export default SendToNetsuiteButton;
